import React from 'react';

const CircleArrowBlack = () =>
<svg className="circle-arrow-black" xmlns="http://www.w3.org/2000/svg" width="47.555" height="47.233" viewBox="0 0 47.555 47.233">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rectangle_5409" data-name="Rectangle 5409" width="47.555" height="47.233" transform="translate(3839.669 69.089)" fill="none"/>
    </clipPath>
    <clipPath id="clip-path-3">
      <rect id="Rectangle_5407" data-name="Rectangle 5407" width="65.555" height="55.233" transform="translate(3830.669 62.089)" fill="none"/>
    </clipPath>
  </defs>
  <g id="Group_10423" data-name="Group 10423" transform="translate(-3839.669 -69.089)">
    <g id="Group_10422" data-name="Group 10422" clipPath="url(#clip-path)">
      <g id="Group_10421" data-name="Group 10421">
        <g id="Group_10420" data-name="Group 10420" clipPath="url(#clip-path)">
          <g id="Group_10419" data-name="Group 10419" opacity="0.9">
            <g id="Group_10418" data-name="Group 10418">
              <g id="Group_10417" data-name="Group 10417" clipPath="url(#clip-path-3)">
                <path id="Path_2472" data-name="Path 2472" d="M3863.446,116.322a23.617,23.617,0,1,0-23.777-23.616,23.7,23.7,0,0,0,23.777,23.616" fill="#1a1818"/>
              </g>
            </g>
          </g>
        </g>
      </g>
      <line id="Line_99" data-name="Line 99" x1="20.351" transform="translate(3852.115 92.981)" fill="none" stroke="#f6f6f3" strokeWidth="2.6"/>
      <path id="Path_2473" data-name="Path 2473" d="M3866.9,85.689l6.119,7.292-6.119,6.7" fill="none" stroke="#f6f6f3" strokeWidth="2.6"/>
    </g>
  </g>
</svg>;

export default CircleArrowBlack;
